var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9289 19.9284C10 22.8574 10 27.5714 10 36.9995V43.6662C10 53.0943 10 57.8083 12.9289 60.7372C15.8579 63.6662 20.5719 63.6662 30 63.6662H50C59.4281 63.6662 64.1421 63.6662 67.0711 60.7372C70 57.8083 70 53.0943 70 43.6662V36.9995C70 27.5714 70 22.8574 67.0711 19.9284C64.1421 16.9995 59.4281 16.9995 50 16.9995H30C20.5719 16.9995 15.8579 16.9995 12.9289 19.9284ZM21.849 27.228C20.3172 26.2068 18.2477 26.6207 17.2265 28.1525C16.2053 29.6842 16.6192 31.7538 18.151 32.775L36.302 44.8756C38.5413 46.3685 41.4587 46.3685 43.698 44.8756L61.849 32.775C63.3808 31.7538 63.7947 29.6842 62.7735 28.1525C61.7523 26.6207 59.6828 26.2068 58.151 27.228L40 39.3286L21.849 27.228Z",
    fill: "#FF8A5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFou);
export default __webpack_public_path__ + "static/media/fou.222fdd4f033f95eeaf4af9cf9d53705a.svg";
export { ForwardRef as ReactComponent };